module.exports = __webpack_public_path__ + "media/Video05_aggressive.fc66533d.mp4";